import * as React from 'react';
import {AuthWrapper, CreateFormWrapper} from "./share/auth_share_components";
import styled from "styled-components";
import Assets from "../../assets/img/assets";
import {ConstBreakPoint} from "../../../config/styles_const/styles_const";
import Paragraph from "../../common/atom/text/paragraph";

interface IProps {

}

const AuthApplyClientThanksComponent: React.FC<IProps> = (props) => {
    const {  } = props;

    return (
        <React.Fragment>
            <ThanksWrapper>
                <ContentWrapper>
                    <FlexWrapper>
                        <LogoWrapper>
                            <img src={Assets.expertnetwork_logo} />
                        </LogoWrapper>
                        <BodyWrapper>
                            <Paragraph>
                                ありがとうございます、送信が完了しました。
                            </Paragraph>
                            <Paragraph>
                                担当者がご連絡致しますので、それまでお待ちください。
                            </Paragraph>
                        </BodyWrapper>
                    </FlexWrapper>
                </ContentWrapper>
            </ThanksWrapper>
        </React.Fragment>
    )

};

export default AuthApplyClientThanksComponent;

const ThanksWrapper = styled(AuthWrapper)`
    display: flex;
    justify-contents: center;
    align-items: center;
`

const ContentWrapper = styled(CreateFormWrapper)`
    width: 100%;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        padding: 70px;
    }    
`

const LogoWrapper = styled.div`
    margin-bottom: 40px;
    
    & img {
        width: 300px;
    }
`

const FlexWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const BodyWrapper = styled.div`
    text-align: center;
`



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_apply_client_thanks.tsx